module.exports = __webpack_public_path__ + "img/banner-party-text.7453e532.png";